import React, { useMemo } from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { TotalTableFooter } from 'components/dashboard/totalTableFooter'

import { localized } from 'decorators'
import { DashboardItem, COLORS, formatters } from 'components/dashboard'
import { api } from 'store/modules/dashboard'
import { useStyles } from './index.css'

const createPie = ({ data, cx, cellKey, type }) => {
  return (
    <Pie data={data} cx={cx} cy={80} outerRadius={80} labelLine={false} dataKey='value'>
      {data.map((entry, index) => <Cell key={`${cellKey}-${index}`} type={type} fill={COLORS[index % COLORS.length]} />)}
    </Pie>
  )
}

export const StorageStatuses = localized(({ localize }) => {
  const classes = useStyles()
  const [data, setData] = React.useState(null)
  const handleData = React.useCallback(x => setData(x), [])

  const totalCount = useMemo(() => data && data.length > 0 ? data.map(x => x.bottles).reduce((total, curr) => total + curr) : 0, [data])
  const totalPrice = useMemo(() => data && data.length > 0 ? data.map(x => x.totalPrice).reduce((total, curr) => total + curr) : 0, [data])

  return (
    <DashboardItem
      title={localize('dashboard.storageStatuses_title')}
      dataSource={api.getStorageStatuses}
      bodyClassName={classes.root}
      onDataReceived={handleData}>
      {data && <PieChart width={400} height={170}>
        {createPie({ data: data.map(x => ({ name: x.name, value: x.bottles })), cx: 95, cellKey: 'cell-bottles', type: 'bottles' })}
        {createPie({ data: data.map(x => ({ name: x.name, value: x.totalPrice })), cx: 295, cellKey: 'cell-prices', type: 'prices' })}
        <Tooltip formatter={(value, name, props) => formatters(localize)[props.payload.type](value)} />
      </PieChart>}
      {data && <React.Fragment>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell colSpan={3} align='center'>{localize('dashboard.storageStatuses_title')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((x, idx) => <TableRow key={idx}>
                  <TableCell>{x.name}</TableCell>
                  <TableCell align='right'>{formatters(localize).bottles(x.bottles)}</TableCell>
                  <TableCell align='right'>{formatters(localize).prices(x.totalPrice)}</TableCell>
                </TableRow>)}
            </TableBody>
            <TotalTableFooter totalCount={totalCount} totalPrice={totalPrice} />
          </Table>
        </React.Fragment>}
    </DashboardItem>
  )
})
